import { getMetricFromPodiumLevels as r } from "../index5.js";
import { getLevelGlazedFacadeArea as o } from "../level-metrics/index21.js";
const m = (e) => r(e, o);
export {
  m as getPodiumGlazedFacadeArea
};
//# sourceMappingURL=index40.js.map
